<template>
  <div v-if="!emailSent">
    <loader :loading="loading"></loader>
    <div class="container login-page">
      <div v-if="errorMessage.length" class="row justify-content-center">
        <div class="col-md-12 col-lg-8">
          <base-alert class="text-center" type="danger" v-html="errorMessage"></base-alert>
        </div>
      </div>
      <div class="row">

        <div class="col-lg-4 col-md-6 ml-auto">
          <div class="info-area info-horizontal">
            <div class="icon icon-warning">
              <i class="tim-icons icon-alert-circle-exc"></i>
            </div>
            <div class="description">
              <h3 class="info-title">Email Required</h3>
              <p class="description">
                To complete your HSP registration, please supply your current
                email address. A confirmation email will be sent with a link
                to then access the HSP. Thank you for your patience.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 mr-auto">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(addEmail)">
              <card class="card-login card-white">
                <template slot="header">
                  <img src="img/card-primary.png" alt="Background" />
                  <h1 class="card-title">Email</h1>
                </template>

                <div>
                  <validation-provider :rules ="{ email: true, requiredEmail: true }" v-slot="{ errors, untouched }" vid="confirmation">
                    <h6 v-if="errors.length && !untouched" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="email"
                      type="email"
                      placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"
                      v-model="email">
                    </base-input>
                  </validation-provider>
                </div>
                <div>
                  <validation-provider :rules ="{ email: true, requiredEmail: true, confirmed: { target: 'confirmation'} }" v-slot="{ errors, untouched }">
                    <h6 v-if="errors.length && !untouched" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="email2"
                      type="email"
                      placeholder="Confirm Email"
                      addon-left-icon="tim-icons icon-email-85"
                      v-model="email2">
                    </base-input>
                  </validation-provider>
                </div>

                <div slot="footer">
                  <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                    Submit
                  </base-button>
                </div>
              </card>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <div class="info-area info-horizontal">
          <div class="icon icon-primary">
            <i class="tim-icons icon-check-2"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Email Sent!</h3>
            <p class="description">
              Please check your inbox to complete your email confirmation. If an email doesn't arrive, be sure to check your span or junk mail folder.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters, mapMutations } from 'vuex';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import { confirmEmail } from 'src/modules/adminActions';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
    },
    data() {
      return {
        email: null,
        email2: null,
        loading: false,
        emailSent: false,
        errorMessage: '',
      }
    },
    computed: {
      ...mapGetters(['adminUser'])
    },
    methods: {
      addEmail() {
        this.errorMessage = '';
        this.loading = true;

        let payload = {
          username: this.adminUser.username,
          email: this.email,
          callbackUrl: `${process.env.VUE_APP_URL}/admin/login`
        };

        confirmEmail(payload)
          .then(response => {
            this.handleIdentityResult(response.data);
          })
          .finally(() => this.loading = false);
      },
      handleIdentityResult(identityResult) {
        if(identityResult.errors && identityResult.errors.length) {
          identityResult.errors.forEach(error => {
            this.errorMessage += `${error.description}<br>`
          });
        }
        else {
          this.removeRedirectRoute();
          this.removeAuthenticatedUser();
          this.emailSent = true;
        }
      },
      ...mapMutations([
        'removeRedirectRoute',
        'removeAuthenticatedUser'
      ])
    }
  }
</script>
